import styled from 'styled-components';
import Modal from '../CommonComponents/Modal';
import { VIEWS } from './UpsertAccountModalConstants';

// eslint-disable-next-line
export const StyledModal = styled(Modal)`
  &__content {
    width: ${props => (props.currentView === VIEWS.LINK ? '890px' : '550px')};
    padding: ${props => (props.currentView === VIEWS.LINK ? '20px' : '0')};
    border-radius: 4px;
  }

  #AccountsLinkingStepWorkflow {
    width: 600px;
  }

  .adv-workflow-container-outer {
    padding: 32px;
    min-height: ${props => (props.currentView === VIEWS.LINK ? '600px' : 'auto')};
  }

  .accounts-workflow-link-institution-h2 {
    margin-bottom: 16px !important;
    text-align: left !important;
    font-family: Inter;
    font-weight: 500 !important;
    font-size: 20px !important;
  }
`;
